import { TransportOption } from './../model/transport-option';
import { Injectable } from '@angular/core';
import { AppServerAPI } from '@sdbn/common';
import { Observable } from 'rxjs';
import { ServiceResponse } from '@sdbn/common';
import { Identity } from '@sdbn/common';
import { RoutingRule } from '../model/routing-rule';

@Injectable({
  providedIn: 'root'
})
export class RoutingRuleService {
  constructor(private appServerAPI: AppServerAPI) { }

  getTransportOptions(): Observable<TransportOption[]> {
    return this.appServerAPI.execute<TransportOption[]>('/client/admin/routingrules/transport-options', {});
  }

  getRoutingRules(): Observable<RoutingRule[]> {
    return this.appServerAPI.execute<RoutingRule[]>('/client/admin/routingrules', {});
  }

  createRoutingRule(routingRule: RoutingRule): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/routingrules/create', routingRule);
  }

  saveRoutingRule(routingRule: RoutingRule): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/routingrules/save', routingRule);
  }

  deleteRoutingRule(identity: Identity): Observable<ServiceResponse> {
    return this.appServerAPI.execute<ServiceResponse>('/client/admin/routingrules/delete', identity);
  }
}
